module.exports = __webpack_public_path__ + "static/hero-f84ae999ad05a7ebab3a44b07da3a797.png";